import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useNavigate } from "react-router-dom";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// End

function EditGuard() {
  const navigate = useNavigate();

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // End

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/Guards")}
              />{" "}
              Edit Guard
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Guard Details</div>
            <div className="addAgencyMain">
              <Grid item xs={12} md={12}>
                <div className="addSpotsOutBt AssignDutyBt">
                  <Button
                    className="addSpotsBt"
                    onClick={() => navigate("/Agencies")}
                  >
                    Add Guards Through Agency
                  </Button>
                </div>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <div className="tabLeftDiv">
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <input className="inputSt" placeholder="First Name" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <input className="inputSt" placeholder="Last Name" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <input className="inputSt" placeholder="Contact No." />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <input className="inputSt" placeholder="Email ID" />
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <textarea
                          className="textAriaSt"
                          placeholder="Address"
                        ></textarea>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <input
                          className="inputSt"
                          placeholder="Qualification"
                        />
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="tabRightDiv">
                    <h4 className="documeUpload">Documents Upload</h4>
                    <div className="doqumentDiv2">
                      <span>Adhaar Card</span>
                      <div className="progresDoneOut">
                        <div className="progresDone"></div>
                        <CloseIcon />
                      </div>
                      <p>document1.jpg</p>
                    </div>
                    <div className="doqumentDiv1">
                      <span>PAN Card</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>

                    <div className="doqumentDiv1">
                      <span>Document 1</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>
                    <div className="doqumentDiv1">
                      <span>Document 2</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Button
                    className="addBt"
                    // onClick={() => navigate("/AddedGuardSucce")}
                    onClick={handleClickOpen("body")}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Committee Member</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <div className="succesMain">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
                    <h4>Success !</h4>
                    <p>Mile Dormon is added successfully.</p>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default EditGuard;
